import API from "core/api/axios/base";
import UserInfoErrorHandler from "core/api/handler/UserInfoErrorHandler";
import Cookies from "universal-cookie";

export default async function getResetPasswordUrlApi(urlData) {
    const cookies = new Cookies();
    const accesstoken = cookies.get("accesstoken");
    const baseUrl = process.env.REACT_APP_USER_GENERATE_JWE_URL;
    const config = {
        headers: {
            "content-type": "application/json",
            "x-client-key": process.env.REACT_APP_CLIENT_KEY,
            Authorization: "Bearer " + accesstoken,
            "x-accesstoken": accesstoken,
            "x-credentials-key": process.env.REACT_APP_X_CREDENTIALS_KEY,
        },
        withCredentials: true,
    };

    const response = await API.post(baseUrl, urlData, config)
        .then(({ data }) => data)
        .catch((error) => {
            const errorHandler = UserInfoErrorHandler(error);

            if (errorHandler?.error) {
                return errorHandler;
            }

            return {
                code: error?.status || "no-code",
                error: {
                    errorCode: "USER_DATA_NOT_FOUND",
                },
            };
        });

    return response;
}
